import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { motion, useAnimation, AnimatePresence  } from "framer-motion"; // useReducedMotion
import ClickAwayListener from '@mui/material/ClickAwayListener';
import styled from '@emotion/styled'
import {List, Icon, Divider,Paper, Grid, Collapse, Link as MUILink } from '@mui/material';
import ChevronDownIcon from '@mui/icons-material/ExpandMore';
import ChevronUpIcon from '@mui/icons-material/ExpandLess';
import ListItem from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MDBox from "dashboard/components/MDBox"
import MDTypography from "dashboard/components/MDTypography";

const isIcon = icon => icon && icon.name ;
const MenuAncer = styled(motion.div)`
    position: absolute;
    fontSize: 30;
    width: 1em;
    height: 1em;
    pointerEvents: none;
    fill: ${(props) => props.darkMode ? '#383838' : 'rgb(255, 255, 255)'};
    stroke: ${(props) => props.darkMode ? 'rgb(30 30 30)' :' rgb(218, 226, 231)'};
    strokeWidth: 2px;
    top: -20px;
    `;



const subMenuAnimate = {
  exit: {
    opacity:0,
    y:40,
  },
  closed: { opacity:0, y:40 },
  open:  {
        opacity: 1,
        y:0,
        transition: {
          type: "spring",
          duration: 0.4,
          delayChildren: 0.2,
          staggerChildren: 0.05,
        }
      },
};


const MotionListItem = motion(ListItem);
const MotionListContainer = motion(Paper);

export default function MegaMenu({item, limit, darkMode,  open, setOpen, ancerX}) {
  // Imperative
  const controls = useAnimation();
  // const reducedMotion = useReducedMotion();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useLayoutEffect(() => {
    // Function to update the 'isMobile' state based on the window width
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Add a window resize event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  

  const handleMouseLeaveControls = e => {
    const { target } = e;
    /* eslint-disable */
    controls.start("closed");
    if(target && typeof (target.className.split) === "function" && (target.className.split(' ').indexOf("mega-menu-with-children")>=0 ||
      target.parentNode.className.split(' ').indexOf("mega-menu-with-children")>=0)
    ){
      controls.start("open");
    }
  }

  const onComplete = e =>{
    e === "closed" && setOpen(false)
  }
  
  useEffect(() => {
    open && controls.start("open");
    return () => {
      controls.start("closed");
    }
  }, [open]);

  return (
      <AnimatePresence initial={false}>
        {open && (
        <div style={{
              position: 'absolute',
              zIndex: 999,
              top: 65,
              left: 0,
              display: 'flex',
              width: '100vw',
              placeContent: 'center',
              placeItems: 'start',
              left: '50%',
              transform:' translate(-50%, -50%)'
              }}    
          >
          <ClickAwayListener onClickAway={handleMouseLeaveControls}>
            <MotionListContainer 
                initial="exit"
                layout
                layoutId={`megaMenu-container--index`}
                onMouseLeave={handleMouseLeaveControls}
                onAnimationComplete={onComplete}
                variants={subMenuAnimate}
                animate={controls}
                sx={{ p: {xs:1.5, md:2, lg:3}, position:"fixed", width:"80%", zIndex:1024,  borderRadius:2}}
                elevation={24}
              >
              <MenuAncer 
                variants={ancerX}
                initial="exit"
                animate="open"
                darkMode={darkMode}
              >
                <svg display="block" viewBox="0 0 30 30"><g transform="rotate(0 15 15)"><path fill="none" d="M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"></path><path stroke="none" d="M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z"></path></g></svg>
              </MenuAncer>
              <Grid className="mega-menu-container" container sx={{ alignItems: 'start',m:"auto", overflow:"auto", maxHeight:"calc(100vh - 270px)"}}>
              {item.children && item.children.map( (childItem, i) => (
                <Grid xs={12} sx={{display:"flex"}} key={`childItem -${i}-menu`} item lg={2.4}>
                  <MDBox sx={{textAlign: 'center',width:"calc(100% - 15px)", pr:2}}>
                  {childItem.children && childItem.children.length > 0 ? <MDTypography  variant="h6" sx={{textAlign:"center"}}>{childItem.title}</MDTypography>
									: <MUILink sx={{ textAlign: 'center', cursor:"pointer", p:1, "&:hover":{color:"#23346a"} }} key={childItem.id} component={Link} to={`/${childItem.link?.name}`} >{isIcon(childItem.icon)  && <Icon sx={{mt:.5, mr:1}}>{childItem.icon.name}</Icon>} {childItem.title}</MUILink>}
                  <Divider sx={{width:"100%"}}/>
                  <List dense>
                  {childItem?.children && childItem.children.slice(0, limit !== 0 ? limit : childItem.children.length).map((child, i) => <NestedList MUILink={MUILink} isDivider={i < childItem.children.length - 1} index={i} key={`${child.title}-${i}-sub-menu`} child={child} isMobile={isMobile}/>)}
                  </List>
                  {childItem.children.length > limit && (
                  // <MUILink color="primary" sx={{ textAlign: 'center', cursor:"pointer", p:1, "&:hover":{color:"#23346a"} }} key={childItem.id} component={Link} to={`/products/${childItem.title}`} >Afficher <Icon sx={{mt:1, mr:1}}>add</Icon></MUILink>
                  <ListItem button component={Link} to={`/products/${childItem.title}`}>
                    <ListItemText primary="Afficher" primaryTypographyProps={{ 
                      fontSize: '1rem', 
                      color: 'primary',    
                      fontWeight: 600,
                      textAlign : "right"
                    }} />
                    <ListItemIcon>
                      <Icon sx={{mt:1, mr:1}}>add</Icon>
                    </ListItemIcon>
                  </ListItem>
                  )} 
                  {isMobile && childItem?.children && <Divider orientation="horizontal" sx={{ width:"auto" }} />}
                  </MDBox>
                  {i < item.children.length - 1 && !isMobile  && <Divider orientation="vertical" sx={{ ml: -1, height:"auto" }} />}
                </Grid>    
              ))}
              </Grid>
            </MotionListContainer>
          </ClickAwayListener>
        </div>)}
      </AnimatePresence>
  );
}

export function NestedList({child, index, isDivider, MUILink, isMobile}) {
  const [open, setOpen] = useState(null);

  const handleClick = index => {
    setOpen(index);
  };

  return (
    <>
      {child.children && child.children.length > 0  ? 					
        (<>
          <MotionListItem
            transition={{ delay: 0.1 * index }}
            onClick={()=>handleClick(index)}
            sx={{px:1.5, textAlign:!isMobile ? "left" : "center",  "&:hover":{color:"#23346a"}}}
            component={MUILink}
            >
           {isIcon(child.icon) &&  <ListItemIcon sx={{maxWidth:30, minWidth :30}}>
              <Icon>{child.icon?.name}</Icon>
            </ListItemIcon>}
            <ListItemText>
              {child.title}
          </ListItemText>
          {open === index ? <ChevronUpIcon /> : <ChevronDownIcon />}
          </MotionListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List dense>
              {child.children.map((child, i) => (
                <NestedList MUILink={MUILink} key={`${child.title}-${i}-sub-menu`} index={i} child={child} isMobile={isMobile} />
              ))}
            </List>
          </Collapse>
          </>
        )
        : <MotionListItem
              transition={{ delay: 0.1 * index }}
              onClick={handleClick}
              sx={{px:1.5, textAlign:!isMobile ? "left" : "center",  "&:hover":{color:"#d6111b"}}}
              to={child.link?.type === 3 ?  `/${child.link?.slug}` : `/${child.link?.name}`} 
              component={Link}
              >
              {isIcon(child.icon) && <ListItemIcon sx={{maxWidth:30, minWidth :30}}>
                <Icon>{child.icon?.name}</Icon> 
              </ListItemIcon>}
              <ListItemText>
                {child.title}
            </ListItemText>
          </MotionListItem>}
       {isDivider && <Divider sx={{ width: "100%", my:.5 }} />}
    </>
  )
}
